export default __webpack_public_path__ + "static/media/widget-collapse.5963a983.svg";